<template>
  <div id="new_head_outer">
    <div class="news-title">{{item.actionTitle}}</div>
    <div class="news-desc">
      <span>{{itemDateText(item)}}</span>
      <span v-if="false" style="margin-left: 30px;">{{item.address}}</span>
      <share-select style="margin-left: 15px;" v-bind:share-object="shareObj" />
    </div>
  </div>
</template>

<script>
  import ShareSelect from "../share/ShareSelect";

export default {
  name: "NewsDetailHead",
  props: ['item'],
  components: {
    ShareSelect
  },
  data() {
    return {
      shareList: [
        {
          text: '微信好友',
          m_share: 'weixin',
          span: '\ue609'
        },
        {
          text: '朋友圈',
          m_share: 'qqxiaoyou',
          span: '\ue68c'
        },
        // {
        //   text: 'QQ好友',
        //   nativeshare:'qqFriend',
        //   m_share: 'qq',
        //   span: '\ue680'
        // },
        {
          text: '新浪微博',
          m_share: 'weibo',
          span: '\uea8c'
        },
      ],
      showQrCard: false,
      defaultImage: 'https://img.shslqxh.com/shl_share_default.png',
    }
  },
  computed: {
    shareObj() {
      let item = this.item;
      return {
        title: item.actionTitle == null ? '' : item.actionTitle,
        desc: item.newsTitle == null ? '' : item.newsTitle,
        link: window.location.href,
        imgUrl: this.postImage,
      }
    },
    postImage() {
      if (this.item == null) {
        return this.defaultImage;
      }
      let imageUrls = this.item.imageUrls;
      if (imageUrls == null || imageUrls == '') {
        return this.defaultImage;
      }
      let reg = new RegExp(/[?,]/,'g');
      let temp = imageUrls.split(reg);
      return temp[0];
    }
  },
  mounted() {
  },
  methods: {
    itemDateText(item) {
      let date = this.$moment(item.createTime);
      if (date.isValid()) {
        return date.format('yyyy-MM-DD');
      }
      return '';
    },
  }
}
</script>

<style scoped>
  #new_head_outer {
    /*background-color: yellow;*/

  }

  .news-title {
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }

  .news-desc {
    text-align: center;
    font-size: 0.8rem;
    color: #666;
    margin-top: 20px;
  }

  .news-desc a {
    text-decoration: none;
    color: #666;
    display: inline-block;
  }
  .news-desc a:first-child {
    margin-left: 30px;
  }
  .news-desc a:not(:first-child) {
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/news/NewsDetailHead.vue